<template>
  <div class="contact-section">
    <div class="container-fluid px-0">
      <div class="row justify-content-center m-0">
        <div class="col-12 col-lg-10">
          <div class="contact-wrapper">
            <!-- Contact Info Card -->
            <div class="contact-info-card">
              <h3 class="contact-title">SUSISIEKITE</h3>
              <div class="contact-divider"></div>
              <div class="contact-info">
                <div class="contact-item">
                  <div class="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div class="contact-details">
                    <p class="contact-label">Telefonas</p>
                    <a href="tel:+37061692311" class="contact-value">+370 6 16 92 311</a>
                  </div>
                </div>
                <div class="contact-item">
                  <div class="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div class="contact-details">
                    <p class="contact-label">El. paštas</p>
                    <a href="mailto:info@arunvilkasa.lt" class="contact-value">info@arunvilkasa.lt</a>
                  </div>
                </div>
                <div class="contact-item">
                  <div class="contact-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div class="contact-details">
                    <p class="contact-label">Adresas</p>
                    <p class="contact-value">Jieznas, Stoties g. 12</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contact Form Card -->
            <div class="contact-form-card">
              <h3 class="contact-title">SIŲSTI PRANEŠIMĄ</h3>
              <div class="contact-divider"></div>
              <form class="contact-form">
                <div class="form-group-modern">
                  <input 
                    type="text" 
                    class="form-input-modern" 
                    placeholder="Jūsų vardas"
                    required
                  >
                </div>
                <div class="form-group-modern">
                  <input 
                    type="email" 
                    class="form-input-modern" 
                    placeholder="El. pašto adresas"
                    required
                  >
                </div>
                <div class="form-group-modern">
                  <textarea 
                    class="form-input-modern form-textarea" 
                    rows="4" 
                    placeholder="Jūsų pranešimas"
                    required
                  ></textarea>
                </div>
                <button type="submit" class="btn-modern">
                  <span>SIŲSTI</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                  </svg>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact"
}
</script>

<style scoped>
.contact-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 80px 20px;
}

.contact-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-info-card,
.contact-form-card {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.contact-info-card:hover,
.contact-form-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.15);
}

.contact-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
  text-align: center;
}

.contact-divider {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  margin: 0 auto 30px;
  border-radius: 2px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.contact-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.contact-icon svg {
  width: 24px;
  height: 24px;
}

.contact-details {
  flex: 1;
}

.contact-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 4px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.contact-value {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  color: #1a1a1a;
  font-weight: 600;
  text-decoration: none;
  display: block;
  transition: color 0.3s ease;
}

.contact-value:hover {
  color: #dc3545;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group-modern {
  position: relative;
}

.form-input-modern {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.form-input-modern:focus {
  outline: none;
  border-color: #dc3545;
  background: white;
  box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
}

.btn-modern {
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
  margin-top: 10px;
}

.btn-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

.btn-modern:active {
  transform: translateY(0);
}

.btn-modern svg {
  width: 20px;
  height: 20px;
}

@media (max-width: 992px) {
  .contact-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .contact-info-card,
  .contact-form-card {
    padding: 30px 24px;
  }
}

@media (max-width: 576px) {
  .contact-section {
    padding: 60px 15px;
  }
  
  .contact-info-card,
  .contact-form-card {
    padding: 24px 20px;
  }
  
  .contact-title {
    font-size: 1.5rem;
  }
}
</style>